import {TIMESTAMP_MULTIPLY} from './constants';

/**
 * Get the current date
 * @returns {number}
 */
export const getNow = () => Date.now();

/**
 * Transform the timestamp from the back to the date in milliseconds and
 * set the correct GMT difference
 * @param timestamp received from the back
 * @returns {Date} the correct value to work with dates in the frontend
 */
export const getCurrentDate = timestamp => {

    const date = new Date(timestamp * TIMESTAMP_MULTIPLY);

    return date;
};

/**
 * Returns the date and the hour in an specific format
 * example: dd/mm/yyyy - hh/mm
 */
export const getFormatTime = (formatDate, formatTime, datetime) => {

    const date = formatDate(datetime, {
        year:  'numeric',
        month: 'numeric',
        day:   'numeric'
    });

    const time = formatTime(datetime, {
        hour:   'numeric',
        minute: 'numeric'
    });

    return `${date} - ${time}`;

};

export const getPreviousMonth = date => {
    // If we send a month return the previous one
    // Returns by default the previous month of the current one

    const current = date === undefined ? new Date() : new Date(date);

    current.setMonth(current.getMonth() - 1);

    const newDate = new Date(current.getUTCFullYear(), current.getMonth(), 10); // Create a new date with the previous month
    const prevDate = Date.parse(newDate);

    return prevDate;

    // 1641034800 JAN
    // 1643713200 FEB
    // 1646132400 MAR
};

export const getLast12Months = (date, includeCurrentMonth = false) => {
    const last12 = {
        monthNames:   [],
        monthNumbers: []
    };
    const current = new Date(date);
    const d = new Date(current.getUTCFullYear(), current.getMonth(), 1);
    const monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthNumber = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

    if (includeCurrentMonth) {
        d.setMonth(d.getMonth());
        last12.monthNames.push(`${monthName[d.getMonth()]} ${d.getFullYear()}`);
        last12.monthNumbers.unshift(`${d.getFullYear()}${monthNumber[d.getMonth()]}`);
    }

    for (let i = 0; i <= 11; i++) {
        d.setMonth(d.getMonth() - 1);
        last12.monthNames.push(`${monthName[d.getMonth()]} ${d.getFullYear()}`);
        last12.monthNumbers.unshift(`${d.getFullYear()}${monthNumber[d.getMonth()]}`);
    }

    return last12;
};

export const getDateFromTimestamp = timestamp => {
    const date = new Date(timestamp);
    const month = date.getMonth() + 1; // Because JAN -> 0, FEB -> 1 ....
    const year = date.getUTCFullYear();

    return `${year}-${month}`;
};



// WEBPACK FOOTER //
// ./src/util/date.js